import {getCategoriesOrderedTree, getCategorisedObjectsTree} from './tree';

export const DCS_ORDERED_TREE_ROOT = {
  CatCode: 'DCS',
  labels: {
    en: 'Default Category Scheme', /* TODO: translatable */
    it: 'Category Scheme di Lavoro'
  }
};

export function getCubesTree(cubesJson, dcsJson) {
  return getCategorisedObjectsTree(
    cubesJson,
    [{
      ...DCS_ORDERED_TREE_ROOT,
      children:
        getCategoriesOrderedTree(
          dcsJson,
          'children',
          (cat, anch) => anch ? (cat.ParCode === anch.CatCode) : (cat.ParCode !== null),
          (a, b) => (a.Code || -1) - (b.Code || -1) || a.CatCode - b.CatCode
        )
    }],
    'children',
    (a, b) => a.Code - b.Code,
    (obj, cat) => cat ? (obj.IDCat === cat.IDCat) : (obj.IDCat !== null),
    'CatCode',
    'labels',
    true
  );
}




// WEBPACK FOOTER //
// ./src/utils/treeBuilders.js